import Vue from 'vue'
import Component from 'vue-class-component'
// componemt
import { FullMasterTemplate } from '@/modules/@appbase/templates'
import SearchContainer from '@home/containers/SearchContainer/SearchContainer.vue'
import GnbLeftView from '@gnb/views/GnbLeft/GnbLeftView.vue'

@Component({
    components: {
        FullMasterTemplate,
        SearchContainer,
        GnbLeftView
    }
})
export default class SearchView extends Vue {
}